export default ".responsive {\n  width: 100%;\n  height: auto;\n}"